const { createContext } = require("react");

export const SettlementContext =  createContext()